import axios from 'axios'
export const createAxios = () => {
  return axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 6000
  })
}
